module.exports = __webpack_public_path__ + "img/project-thumb.fcd5f084.png";